
import { Video, Radio } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PostTypeSelectorProps {
  onSelectVideo: () => void;
  onSelectCast: () => void;
  onBack: () => void;
}

export const PostTypeSelector = ({ onSelectVideo, onSelectCast, onBack }: PostTypeSelectorProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between">
        <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-full">
          ←
        </button>
        <h2 className="text-lg font-semibold">Create Post</h2>
        <div></div>
      </div>

      <div className="p-4 space-y-4">
        <h3 className="text-xl font-semibold text-center text-gray-800 mb-8">
          What would you like to share?
        </h3>

        {/* Image or Video Post Option */}
        <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <div className="flex items-center gap-4 mb-4">
            <div className="bg-accent-soft-bg p-3 rounded-full">
              <Video className="text-accent-solid" size={24} />
            </div>
            <div>
              <h4 className="font-semibold text-ink-primary">Image or Video Post</h4>
              <p className="text-sm text-ink-body">Share your farming progress</p>
            </div>
          </div>
          <p className="text-sm text-ink-body mb-4">
            Record or upload images and videos to show your crops, share farming techniques, 
            or document your agricultural journey.
          </p>
          <Button 
            onClick={onSelectVideo}
            className="w-full h-10 rounded-xl bg-accent-solid text-white hover:bg-orange-700 active:bg-orange-800 focus:ring-2 focus:ring-orange-300"
          >
            Create Image or Video Post
          </Button>
        </div>

        {/* Cast Post Option */}
        <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <div className="flex items-center gap-4 mb-4">
            <div className="bg-iso-soft-bg p-3 rounded-full">
              <Radio className="text-iso-solid" size={24} />
            </div>
            <div>
              <h4 className="font-semibold text-ink-primary">Cast (ISO Request)</h4>
              <p className="text-sm text-ink-body">Broadcast what you're looking for</p>
            </div>
          </div>
          <p className="text-sm text-ink-body mb-4">
            Send out an "In Search Of" request to farmers within your chosen radius. 
            Perfect for finding crops, equipment, or expertise.
          </p>
          <Button 
            onClick={onSelectCast}
            className="w-full h-10 rounded-xl bg-iso-solid text-white hover:bg-violet-700 active:bg-violet-800 focus:ring-2 focus:ring-violet-300"
          >
            Create Cast
          </Button>
        </div>

        {/* Info */}
        <div className="bg-blue-50 rounded-xl p-4 border border-blue-200 mt-6">
          <p className="text-sm text-blue-700 text-center">
            💡 Choose Image or Video Posts to share your farming activities or Cast to find what you need from other farmers
          </p>
        </div>
      </div>
    </div>
  );
};
